import axios from 'axios';

let API_BASE_URL = process.env.REACT_APP_API_URL;

export const sendRegistrationInterestEmail = async (formData) => {
  console.log(formData, "formData ________");

  try {
    // Build the HTML message with all form fields
    const message = `
      <div style="font-family: Poppins, sans-serif; max-width: 600px; margin: 0 auto; background-color: #f9f9f9; border-radius: 12px; overflow: hidden; border: 1px solid #e0e0e0;">
        
        <!-- Header banner -->
        <div style="background-color: #d18b4e; padding: 20px; text-align: center;">
          <h2 style="margin: 0; color: white; font-size: 24px;">Smart Acharya</h2>
          <p style="margin: 5px 0 0; color: #fdf8ed; font-size: 14px;">New Registration</p>
        </div>

        <!-- Main content -->
        <div style="padding: 20px; background-color: #ffffff;">
          <p style="font-size: 16px; color: #333;">Dear <strong>Smart Acharya Team</strong>,</p>
          <p>We have received an expression of interest from <strong>${formData.firstName} ${formData.lastName}</strong>. Please find the registration details below for your review and further action.</p>

          <!-- Personal Information -->
          <div style="background-color: #f5f5f5; padding: 12px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #5c3e21; margin-top: 0;">📋 Personal Information</h3>
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="padding: 6px 0; width: 35%;"><strong>Full Name:</strong></td>
                <td>${formData.firstName} ${formData.lastName}</td>
              </tr>
              <tr>
                <td style="padding: 6px 0;"><strong>Email:</strong></td>
                <td>${formData.email}</td>
               </tr>
              <tr>
                <td style="padding: 6px 0;"><strong>Phone:</strong></td>
                <td>${formData.telephone || 'Not provided'}</td>
               </tr>
                <tr>
                <td style="padding: 6px 0;"><strong>I am a:</strong></td>
                <td>${formData.userType}</td>
               </tr>
            </table>
          </div>

          <!-- Address Details -->
          <div style="background-color: #fef5e8; padding: 12px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #d18b4e;">
            <h3 style="color: #5c3e21; margin-top: 0;">🏠 Address Details</h3>
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="padding: 6px 0; width: 35%;"><strong>First line of address:</strong></td>
                <td>${formData.addressLine1 || 'Not provided'}</td>
               </tr>
              <tr>
                <td style="padding: 6px 0;"><strong>City / Town:</strong></td>
                <td>${formData.city || 'Not provided'}</td>
               </tr>
              <tr>
                <td style="padding: 6px 0;"><strong>Postcode:</strong></td>
                <td>${formData.postcode || 'Not provided'}</td>
               </tr>
              <tr>
                <td style="padding: 6px 0;"><strong>Country:</strong></td>
                <td>${formData.country || 'UK'}</td>
               </tr>
            </table>
          </div>

          <!-- Interest Details -->
          <div style="background-color: #e8f4f8; padding: 12px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #5c3e21; margin-top: 0;">🎯 Area of Interest</h3>
            <p> ${formData.areaOfInterest || 'Not specified'}</p>
          </div>
        </div>

        <!-- Footer -->
        <div style="background-color: #d18b4e; padding: 15px; text-align: center; color: white; font-size: 12px;">
          Team Smart Acharya<br/>
          <small>This is an automated notification from the registration system.</small>
        </div>
      </div>
    `;

    const payload = {
      to_email_address: process.env.REACT_APP_TO_EMAIL_ADDRESS,
      message: message,
      subject_line: "Smart Acharya : New Registration Interest Received",
      from_email_address: process.env.REACT_APP_FROM_EMAIL_ADDRESS,
    };

    const response = await axios.post(`${API_BASE_URL}api/sendMailUk`, payload);
    // const response = await axios.post(`${API_BASE_URL}api/sendMail`, payload);
    console.log("Email sent:", response.data);
    if (response.data.status == 100) {
      sendRegistrationSuccessEmailToUser(formData);
    }
    return { success: true, message: "Email sent successfully" };
  } catch (error) {
    console.error("Email sending error:", error);
    return { success: false, message: error.message };
  }
};


const sendRegistrationSuccessEmailToUser = async (formData) => {
  console.log(formData, "formData ________");

  try {
    const message = `
      <div style="font-family: Poppins, sans-serif; max-width: 500px; margin: 0 auto; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1); border: 1px solid #f0e0d0;">
        
        <!-- Header with brand colour -->
        <div style="background-color: #8C5021; padding: 24px 20px; text-align: center;">
          <h2 style="margin: 0; color: white; font-size: 28px; letter-spacing: 1px;">Smart Acharya</h2>
          <p style="margin: 8px 0 0; color: #fdf8ed; font-size: 14px;">Empowering tutors, schools & learners through AI driven education</p>
        </div>

        <!-- Main content --> 
        <div style="padding: 30px 24px; background-color: #ffffff;">
          <p style="font-size: 18px; color: #5c3e21; font-weight: bold;">Dear ${formData.firstName},</p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333; margin-top: 16px;">
            Thank you for registering your interest in Smart Acharya.
          </p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333;">
            We're excited to have you join our growing community of educators, learners, and innovators who are passionate about transforming education through technology.
          </p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333;">
            Your interest has been successfully recorded, and we'll keep you updated on important announcements, product launches, early access opportunities, and upcoming events.
          </p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333;">
            In the meantime, if you have any questions or would like to learn more about our platform, please feel free to reply to this email. We'd be happy to help.
          </p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333;">
            Thank you once again for your interest in Smart Acharya. We look forward to sharing this journey with you.
          </p>
          
          <p style="font-size: 16px; line-height: 1.5; color: #333;">
            Best regards<br/>
             <br/>
            The Founders<br/>
            Smart Acharya<br/>
            <a href="mailto:Info@smartacharya.com" style="color: #8C5021; text-decoration: none;">Info@smartacharya.com</a><br/>
            <a href="https://www.smartacharya.com" style="color: #8C5021; text-decoration: none;">www.smartacharya.com</a>
          </p>

          <img src="https://contentfs.acharya4life.com:8448/files/smartAcharyaLogo.jpg" alt="Smart Acharya Logo" style="display: block; max-width: 120px; height: auto; margin-top: 20px;" />
        </div>
      </div>
    `;

    const payload = {
      to_email_address: formData.email,
      message: message,
      subject_line: "Welcome to Smart Acharya",
      from_email_address: process.env.REACT_APP_FROM_EMAIL_ADDRESS,
    };

    const response = await axios.post(`${API_BASE_URL}api/sendMailUk`, payload);
    // const response = await axios.post(`${API_BASE_URL}api/sendMail`, payload);
    console.log("User confirmation email sent:", response.data);
    return { success: true, message: "User email sent successfully" };
  } catch (error) {
    console.error("Email sending error:", error);
    return { success: false, message: error.message };
  }
};